<template>
  <v-menu
    v-model="navDrawer"
    :close-on-content-click="false"
    transition="v-scale-transition"
    min-width="auto"
  >
    <template v-slot:activator="{ props }">
      <div v-bind="props">
        <v-icon>mdi-menu</v-icon>
      </div>
    </template>

    <NavigationDrawerVue />
  </v-menu>
</template>

<script>
import NavigationDrawerVue from "./NavigationDrawer.vue";

export default {
  name: "mobileNav",

  data() {
    return {
      navDrawer: false,
    };
  },

  components: {
    NavigationDrawerVue,
  },

  mounted() {
    window.addEventListener("closeNavMenu", (value) => {
      this.navDrawer = false;
    });
  },
};
</script>
